import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const cn = {
login:{
buttoo:{
    add:'新增'
}
},
dialog:{
buttton:{
    close:'关闭'
},
ReportError:{
      next:'Next',
 h1:'Report Errors allows users to communicate with us to solve any data issues and improve data quality.',
 li1:'If you find any data problems or have a question about this data',
 li2:'If you want to contribute company information to improve this data',
 li3:'If you choose not to disclose your own company information that you might consider private',
 li4:'If you have any constructive suggestions for us to improve services',
 h2:"All comments submitted are subject to data verification. Users must complete your own user profile as our representative may contact you for authentication and verification of your company any rights to represent your company."
},
},
Home:{
  Applications:'Applications',
  SearchCompanies:'Search Companies',
  SearchTrade:'Search Trade',
  SearchRisks:'Search Risks',
  SearchCountries:'Search Countries',
  SearchNews:'Search News',
  SearchLeads:'Search Leads',
 selectCountry:'选择国家地区',
 keWord:'关键词',
 firstWord:"首词",
 searchCompanyNum:"Search 500+ million companies in 200+ countries and territories",
 search:'搜索',
 homeSeachTitle:'聚焦全球搜索',
 homeTitleDetail:'CSI是一家数据驱动的研究和科技公司，专注于信用、风险和大数据领域。它为全球投资者和专业人士提供数字工具，依据大数据利用先进的分析和算法，提供快速、可视化的洞察，从而促进更明智的决策。',
 phoneTitleDetail:'您可以使用手机上的 CSI App 快速搜索、查看和获取公司信息。',
 IndustryAnalysis :'Industry Analysis',
BusinessAnalytics :'Business Analytics',
ImportExportData :'Import-Export Data',
CompanyNews :'Company News',
Sanctions :'Sanctions',
SearchLeads:"Search Leads",
BusinessIntelligence :'Business Intelligence',
CompanyIdentityVerification :'Company Identity Verification',
KYCSolutions :'KYC Solutions',
OwnershipPenetration :'Ownership Penetration',
CompanyFinancialAnalysis:'Company Financial Analysis',
CreditRatings :'Credit Ratings',
CreditReports :'Credit Reports',
ESGRatings :'ESG Ratings',
VendorScreening :'Vendor Screening ',
MarketResearch:'Market Research ' 

},
IndustryStatistics:{
    SubjectCompany:"目标公司",
    Country:"国家/地区",
    Compare:"比较",
    Industry:"行业",
    CompanyType:"公司类型",
    CompanySize:"公司规模",
    CompanyStatus:"公司状态",
    YearsinBusiness:"经营年限",
    CompanyRating:"公司评级"
},
ListofResults:{
  SelectCountry:'Select Country',
  ClearAll:'Clear All',
  SelectIndustry:'Select Industry',
  ListedCompany:'Listed Company',
  YearsinBusiness:'Years in Business',
 Sharethisinformation:'Share this information',
  Pleaseaddress:'Please enter one or more email address',
  Example:'Example',
  message:'message',
  pleaseleaveamessage:'please leave a message',
  Include:'',
  thisaddress:'this company name,ID,address',
  CSIwebsite:'CSI website',
  Update:'Update',
  Iftheavailable:'If the available online data is insufficient or outdated, you can click the “Update” button to request an instant update for a fresh investigated business credit report from our local networking investigators or credit reporting agencies. The cost for this update is 1 credit per company. The update report typically takes between 24 and 72 hours to be delivered.',
  Abusinesscredit :'A business credit report provides detailed information about the subject company’s identification data, registry records, shareholding structure, company history, management description, related companies, actual operations, trade references, financial data and analysis, official public information such as litigation records and sanctions, and credit analysis and assessment.',
  Searchcompanies:'Search more emails on other companies',
  Rowsperpage:'Rows per page'



},
Toolbar:{
    Filter:"筛选",
    Select:"选择",
    Edit:"编辑",
    Sortby:"排序",
    Collect:"收藏",
    Saved:"已保存",
    Compare:"比较",
    Export:"导出",
    Download:"下载",
    Update:"更新",
    Reporterror:"报告错误",
    Share:"分享",
    ascending:'昇順',
    descending:'降順',
    Yourfolder:'カスタムフォルダ'

},
AiZaba:{
whatareyousearchingfor:'what are you searching for',
CreditAnalyst:'Credit Analyst',
Assesses:"Assesses a company'screditworthiness,identifiesfinancial risks,ensuring secure transactionsthrough data analysis andcredit ratings.",
LegalAdvisor:"Legal Advisor",
Provides:'Provides compliance guidance,reviews contracts,andassesseslegarisks to ensure businessoperations align with lawsand avoid disputes.',
BizConsultant:'Biz Consultant',
Optimizes:'Optimizes supply chains,identifiesbuyers, andboosts sales by analyzingmarket trends and offeringtailored strategies to improve efficiency',
EconomicAnalyst:'Economic Analyst',
Analyzes:"Analyzes industry and regional economic trendshelping businesses makeinformed decisions, and staycompetitive."
},
ContentTabs:{
    Background:"公司背景",
    BusinessActivities:"业务活动",
    Performance:"业绩表现",
    Publications:"公共记录",
    CreditOpinion:"信用评价",
    MarketAnalysis:"市场分析",
    Snapshot:"公司快照",
    Profile:"注册资料",
    Ownership:"股东结构",
    RelatedCompanies:"关联公司",
    Management:"管理层",
    Operations:"运营信息",
    Locations:"公司分布",
    Industry:"所属行业",
    ImportExport:"进出口信息",
    SupplyChain:"供应链",
    FinancialHighlights:"财务摘要",
    RatioAnalysis:"财务分析",
    IndustryNorm:"行业平均",
    News:"相关新闻",
    Sanctions:"全球制裁",
    IndustryStatistics:"行业统计",
    RatingAnalysis:"评级分析",
    CompetitiveAnalysis:"竞争力分析",
    Lawsuits:"诉讼"
},
navigationBar:{
Notifications:'通知',//通知
MarkasRead:'标记已读',//标记已读
Viewall:'查看全部',//查看全部
SilverSubscriber:'银级用户',//银级用户
Silversubscriberdate:'银级到期日',//银级到期日
GoldSubscriber:'金级用户',//金级用户
Goldsubscriptiondate:'金级到期日',//金级到期日
AvailableCredits:'可用积分',//可用积分
AddCredits:'购买积分',//购买积分
IndivdualAccount:'个人账号', //个人账号
GroupAccount:'集团账号' //集团账号

},
Snapshot:{
  CompanyDQIdesc:"The Data Quality Index (DQI) employs algorithms to assess different aspects of data, including completeness, validity, reliability of sources, consistency, timeliness, and bilingual support.The index is designed to assess the quality of data on a scale of 1 to 100, with higher scores indicating superior data quality. Algorithms can analyze data based on predefined rules or criteria, enabling objective and standardized measurements.Our Data Quality Index (DQI) serves as a reliable indicator, allowing users to quantitatively assess data quality. This enables data-driven decision-making and enhances the overall value and utility of the data.",
  CountryDQIdesc:"The Data Quality Index (DQI) assesses the reliability, accuracy, and accessibility of data across countries, reflecting differences in digital infrastructure, governance, and transparency. Developed nations typically rank higher due to strong data systems, open policies, and advanced technology, while developing economies often struggle with gaps in infrastructure, regulation, or data-sharing practices. Key factors include government transparency, data protection laws, and technological adoption. A high DQI enables better policymaking and business decisions, while a low score highlights areas needing investment.",
  CompanyDQI:'Company DQI',//公司数据质量指数 DQI
  CountryDQI:'Country DQI',//国家数据质量指数 DQI
  Address:'地址',//地址
  CountyCity:'县/市',//县/市
  ProvinceState:'省/州',//省/州
  CountryRegion:'国家/地区',//国家/地区
  ZipCode:'邮政编码',//邮政编码
  Website:'网站',//网站
  Email:'电邮',//电邮
  Tel:'电话',//电话
  LastUpdate:'最近更新',//最近更新
  DataSource:'数据来源',//数据来源
  LegalStatus:'法定状况',//法定状况
  CoID:'公司ID',//公司ID
  CompanyType:'公司类型',//公司类型
  RegistrationDate:'注册日期',//注册日期
  RegistrationStatus:'注册状态',//注册状态
  Listed:'上市信息',//上市信息
  CurrentOpperations:'经营状况',//经营状况
  IndustryCode:'行业代码',//行业代码
  BusinessActivities:'主营业务',//主营业务
  NoofEmployees:'员工数量',//员工数量
  NoofShareholders:'股东数量',//股东数量
  Management:'管理状况',//管理状况
  Performance:'业绩表现',//业绩表现
  Revenue:'收入',//收入
  Assets:'资产',//资产
  ProfitLoss:'利润',//利润
  Growth:'公司增长',//公司增长
  Competitiveness:'竞争力',//竞争力
  CreditOpinion:'信用状况',//信用状况
  CreditRating:'信用评级',//信用评级
  CreditScore:'信用评分',//信用评分
  ESGRating:'ESG 评级',//ESG 评级
  Solvency:'偿还能力',//偿还能力
  Sanctions:'全球制裁',//全球制裁
},
Profile:{
  CompanyProfile:'基本资料',//基本资料
  CompanyName:'公司名称',//公司名称
  NativeName:'当地名称',//当地名称
  CompanyID:'县/市',//公司 ID
  VATNumber:'VAT号',//VAT号
  StockCode:'股票代码',//股票代码
  Listed:'上市日期',//上市日期
  RegistrationDate:'注册日期',//注册日期
  LegalForm:'公司性质',//公司性质
  CompanyType:'公司类型',//公司类型
  LegalStatus:'注册状态',//注册状态
  Jurisdiction:'司法管辖区',//司法管辖区
  RegisteredAddress:'注册地址',//注册地址
  ProvinceState:'省/州',//省/州
  CountryRegion:'国家/地区',//国家/地区
  ZipCode:'邮政编码',//邮政编码
  OperatingAddress:'经营地址',//经营地址
  LastUpdate:'最近更新',//最近更新
  DataSource:'数据来源',//数据来源
  History:'历史记录',//历史记录
    RegisteredCapital:'Registered Capital',
  PaidinCapital:'Paid-in Capital',
   CountyCity:'County/City'
},
Ownership:{
 UltimateBeneficiary:'最终受益人',//最终受益人
  InvolvingIndividuals:'涉及自然人股东',//涉及自然人股东
  InvolvingEnterprises:'涉及法人股东',//涉及法人股东
  ShareholderLevel:'股东层级',//股东层级x
  Name:'名称',//名称
  Country:'国家/地区',//国家/地区
  Location:'地点',//地点
  Type:'类型',//类型
  Shares:'股份',//股份
  Relation:'关系',//关系
  Individuals :'Individuals',//关系
    PartiesInvolved:'Parties Involved',
  RelatedCompany:'Related Company',
  CompanyShareholders:'Company Shareholders',
  NGOShareholders:'NGO Shareholders',
  NaturalPersonShareholder:'Natural Person Shareholder',
  SubjectInvestments:"Subject's Investments"
},
RelatedCompanies:{
 Total:'相关公司总计',//相关公司总计
  Entities:'法人实体',//法人实体
  Countries:'国家/地区',//国家/地区
  Branches:'分支机构',//分支机构
  RelatedComp:'关联公司',//关联公司
  Name:'名称',//名称
  Country:'国家/地区',//国家/地区
  Location:'地点',//地点
  Type:'类型',//类型
  Shares:'股份',//股份
  Relation:'关系',//关系
  BranchOffices:'Branch Offices',
  Individuals:'Individuals',
},
Management:{
  Total:'管理层',//管理层
  ContactInfo:'联系人信息',//联系人信息
  Countries:'国家/地区',//国家/地区

  Name:'名称',//名称
  Position:'职位',//职位
  Department:'部门',//部门
  Country:'国家/地区',//国家/地区
  ShareholderNot:'是否股东',//是否股东
  Relation:'关系',//关系
  Verification:'已验证',//已验证
  Searchmoreemails:'搜索更多电邮',//搜索更多电邮
  Roles:'角色',//角色
  EducationLevel:'教育程度',//教育程度
  Phone:'电话',//电话
  Email:'电邮',//电邮
  Verified:'已验证',//已验证
  Searchmore:'搜索更多其他公司的电邮',//搜索更多其他公司的电邮
},
Operations:{
    Operations:'Operations',
  LineofBusiness:'业务范围',//业务范围
  BusinessTerritories:'业务区域',//业务区域
  ImportExport:'进出口信息',//进出口信息
  Viewtradeinfo:'查看更多贸易信息',//查看更多贸易信息
  ProductsServices:'产品/服务',//产品/服务
  Products:'产品',//产品
  ProductImage:'产品图片',//产品图片
  ProductName:'产品名称',//产品名称
  ProductDescription:'产品描述',//产品描述
  Details:'详情',//详情
  Addproductinformation :'添加产品信息',//添加产品信息
},
Locations:{
   Locations:"Locations",
  CoName:'公司名称',//业务范围
  Relationship:'关系',//关系
  Country:'国家/地区',//国家/地区
  Location:'地点',//地点
  Address:'地址',//地址
  Edit:'编辑',//编辑
  CompanyLocatiionsMap:'地图中的公司位置',//地图中的公司位置
  Selectaddresstype:'选择地址类型',//选择地址类型
  Subjectcompany:'目标公司',//目标公司
  Subsidiary:'子公司',//子公司
  RegisteredAddress :'注册地址',//注册地址
  OperationAddress :'运营地址',//运营地址
  All :'全部',//全部
},
Industry:{
  IndustryTitle:'公司名称',//IndustryTitle
  IndustryDescription:'关系',//IndustryDescription
  ISIC:'国家/地区',//ISIC
  ISICDescription:'地点',//ISICDescription
  NACE:'地址',//NACEDescription
  NACEDescription:'编辑',//NACEDescription
  NAICS:'NAICS',//NAICS
  NAICSDescription:'NAICSDescription',//NAICSDescription
  CSIC:'CSIC',//CSIC, 
  CSICDescription:'CSICDescription',//CSICDescription
  AAAIC:'AAAIC',//AAAIC
  AAAICDescription :'AAAICDescription',//AAAICDescription
  GICS :'GICS',//GICS
  GICSDescriptio :'GICS 描述',//GICS 描述
},
ImportExport:{
  TotalImportAmount:'Total Import Amount',//进口总额
  TopImportCountry:'Top Import Country',//最大进口国家/地区
  TopImportProduct:'Top Import Product',//最大进口产品
  TotalExport:'Total Export',//出口总额
  TopExportCountry:'Top Export Country',//最大出口国家/地区
  TopExportProduct:'Top Export Product',//最大出口产品
  TradeVolume:'Trade Volume',//贸易额
  ImportShipments:'Import Shipments',//进口量
  ExportShipments:'Export Shipments',//出口量
  ImportCountries:'Import Countries',//进口国家/地区
  ExportCountries:'Export Countries',//出口国家/地区
  ImportVolume:'Import Volume',//进口量
  ExportVolume:'Export Volume',//出口量
  TopSuppliers:'Top Suppliers',//主要供应商
  ByNumberofShipments:'By Number of Shipments',//按出货量
  TopBuyers:'Top Buyers',//主要买家
  ByNumberofShipments:'By Number of Shipments',//按出货量
  ImportQuantity:'Import Quantity',//进口数量
  IncreaseDecreasexRate:'Increase/Decrease Rate',//增/减率
  ExportQuantity:'Export Quantity',//出口数量
  ImportsExportsRecords:'Imports & Exports Records',//进出口记录
  Date:'Datum',//日期
  Product:'Product',//产品
  HSCode:'HS Code',//HS 编码
  BuyerName:'Buyer Name',//买家名称
  Destination:'Destination',//目的地
  SupplierName:'Supplier Name',//供应商名称
  Origin:'Origin',//原产地
  Amount:'Amount',//金额
  Details:'Details',//详情
},
 FinancialHighlight:{
    ProfitabilityRatios:'Profitability Ratios',
  OperatingRatios:'Operating Ratios',
  StructuralRatios:'Structural Ratios',
ProductivityRatios:'Productivity Ratios',
GrowthRatios:'Growth Ratios',
  Revenue:'收入',//收入
  Profit:'利润',//利润
  Growth:'增长',//增长
  Liquidity:'现金流状况',//现金流状况
  FinancialStructure:'融资结构',//融资结构
  CreditOpinion:'信用评估',//信用评估
  RiskIndicator :'风险指标',//风险指标
  Solvencyindex:'偿还指数',//偿还指数
  Year:'年份',//年份
  Change:'变化',//变化
  FinancialHighlights:'关联公司财务数据',//关联公司财务数据
  FinancialHighlightsTitle:'关联公司财务摘要',//关联公司财务摘要
  CompanyName:'公司名称',//公司名称
  CompanyID:'公司ID',//公司ID
  Country:'国家/地区',//国家/地区
  CompanyStatus:'公司状态',//公司状态
  Relations:'关系',//关系
  RatioAnalysis:'关联公司比率分析' //关联公司比率分析
},
IndustryNorms:{
    IndustryStatistics:"行业统计",
    NoofcompaniesintheIndustry:"本行业公司数",
    NooflistedCompaniesintheIndustry:"本行业上市公司数",
    NooflargecompaniesintheIndustry:"本行业大型公司数",
    NoofSMEsintheIndustry:"本行业中小企业数",
    Noofcompaniesinsample:"样本公司数",
    Noofcompaniesinloss:"亏损公司数",
    Observations:"统计观测",
    AverageValue:"平均值",
    MedianValue:"中位数",
    MaximumValue10:"最大值 10%",
    MinimumValue10:"最小值 10%",
    SubjectCompany:"目标公司",
    YearsinBusiness:"在业年限",
    TotalAssets:"总资产",
    TotalEquity:"股东权益",
    Revenue:"营业收入",
    NetEarning:"净利润",
    Returnonassets:"ROE",
    Performance:"业绩表现",
    ProfitabilityRatios:"盈利能力比率",
    Returnonequity:"股东权益回报率",
    Returnonassets:"资产回报率",
    Grossmargin:"毛利率",
    OperatingRatios:"营业比率",
    Stockturnover:"存货周转率",
    Accountsreceivableturnover:"应收账款周转率",
    Assetsturnover:"资产周转率",
    Totalassetturnover:"总资产周转率",
    StructuralRatios:"结构比率",
    Currentratio:"流动比率",
    Quickratio:"速动比率",
    Shareholdersliquidityratio:"股东流动性比率",
    GrowthRatios:"增长率",
    Salesgrowthrate:"销售额增长率",
    Netprofitgrowthrate:"净利润增长率",
    Totalassetsgrowthrate:"总资产增长率"
},
 News:{
  Date:'日期',//日期
  Title:'标题',//标题
  Source:'来源',//来源
  Impact:'影响',//影响
  Searchcompanies:'搜索更多其他公司新闻',//国家/地区
},
 Sanctions:{
  Potentialcompliance:'检测到潜在合规风险',//检测到潜在合规风险
  SeachbuttonNo:'未检测到任何与该公司相关的不良记录',//未检测到任何与该公司相关的不良记录
  SeachbuttonYes:'要搜索更多制裁记录，请点击“搜索制裁”按钮。',//要搜索更多制裁记录，请点击“搜索制裁”按钮。
  SearchSanctions:'搜索制裁',//搜索制裁
  ViewDetails:'查看详情',//查看详情
  Sanctions:'制裁',//制裁
  Potentialcompliancerisks:'潜在合规风险',//潜在合规风险
  IDInfo:'ID 信息',//ID 信息
  IDType:'ID 类型',//ID 类型
  IDDescription:'ID 描述',//ID 描述
  SanctionList:'制裁名单',//制裁名单
  SanctionListInvolved:'涉及的制裁名单',//涉及的制裁名单
  StartDate:'生效日期',//生效日期
  EndDate:'结束日期',//结束日期
  SourceList:'来源名单',//来源名单
  SourceName:'来源名称',//来源名称
  ProfileNotes:'主体资料',//主体资料
  Link:'链接',//链接
},
CreditOpinion:{
    CreditAssessment:"信用评估",
    CreditAssessmentfromtheRelatedCompanies:"关联公司信用评估",
    Year:"年份",
    CreditRating:"信用评级",
    LocalCreditScore:"当地信用评分",
    ProbabilityofDefault:"违约概率",
    SolvencyIndex:"偿还指数",
    CreditLine:"信用额度",
    RiskIndicator:"风险指标",
    RelatedCreditAssessment:"关联信用评估",
    CompanyName:"公司名称",
    CompanyID:"公司ID",
    Country:"国家/地区",
    CompanyStatus:"公司状况",
    Relations:"关系",
    LocalCreditScore:"当地信用评分",
    SolvencyIndex:"偿还指数",
    ProbabilityofDefault:"违约概率",
    RiskIndicator:"风险指标"
},
RatingAnalysis:{
    IndustyAnalysis:"行业分析",
    GeographicAnalysis:"地理分析",
    CompanyTypeAnalysis:"公司类型分析",
    BiusinessScaleAnalysis:"业务规模分析",
    HistoryAnalysis:"历史分析",
    NormalDistribution:"正态分布",
    SubjectCompany:"目标公司",
    Probabilityofthesubjectratinginitsindustry:"目标公司在其行业中的评级概率",
    Maximum:"最大值 10%",
    Mean:"中位值",
    Average:"平均数",
    Minimum:"最小值 10%",
    RatingDistribution:"评级分布",
    Revenue:"营业收入",
    Earning:"盈利",
    TotalAssets:"总资产",
    Subjectratinginitsindustrybyfinancialindicators:"目标公司在其行业中的财务指标评级",
    Best:"最佳",
    Worst:"最差",
    Rankingofsubject:"目标公司在行业中的评级排名",
    Industy:"行业",
    Percentilerank:"百分位排名：得分等于或低于目标公司评级的公司百分比",
    Historicaldevelopmentofsubject:"目标公司在其行业中的评级历史发展",
    IndustryAverage:"行业平均值",
    SubjectRatingChanges:"目标公司评级变化"
},
CompetitiveAnalysis:{
    MarketPosition:"市场地位",
    Revenus:"收入",
    NetEarnings:"净利润",
    NetAssets:"净资产",
    TotalAssets:"总资产",
    Employees:"员工人数",
    Mean:"中位值",
    Average:"平均值",
    Maximum:"最大值 (10%)",
    Worst:"最差值 (10%)",
    Subjectcompany:"目标公司",
    PerformanceComparison:"业绩比较",
    ProfitabilityRatios:"盈利能力比率",
    Grossmargin:"毛利率",
    Returnonassets:"资产回报率",
    Returnonequity:"净资产回报率",
    Average:"平均值",
    OperatingRatios:"营运比率",
    Stockturnover:"存货周转率",
    Assetsturnover:"资产周转率",
    Collectionperiod:"回款期",
    GrowthRatios:"增长率",
    Totalassetsgrowthrate:"总资产增长率",
    Salesgrowthrate:"销售额增长率",
    Netprofitgrowthrate:"净利润增长率",
    StructuralRatios:"结构比率",
    Debtratio:"资产负债率",
    Quickratio:"速动比率",
    Currentratio:"流动比率"
},
AccountCenterMenu:{
SearchinSettings:"在“设置”中搜索",//在“设置”中搜索
Account:"账户",//账户
MyAccount :"我的账户",//我的账户
ContactInfo:"联系信息",//联系信息
AccountSecurity:"账户安全",//账户安全
OrganizationalManagement:"组织管理",//组织管理
UserGroup:"用户组",//用户组
User:"用户",//用户
Role:"角色",//角色
MyDatabase:"我的数据库",//我的数据库
MyUsage:"我的使用情况",//我的使用情况
CompaniesViewed:"查看过的公司",//查看过的公司
ReportsDownloaded:"下载的报告",//下载的报告
ReportUpdatesOrdered:"订购的报告更新",//订购的报告更新
BillingandPayment:"账单和付款",//账单和付款
BillRecords:"账单记录",//账单记录
PaymentRecords:"付款记录",//付款记录
CreditDeductions:"信用扣款",//信用扣款
InvoicesDownloaded:"下载的发票",//下载的发票
UserSettings:"用户设置",//用户设置
Messages:"消息",//消息
Notifications:"通知",//通知
HelpCenter:"帮助中心",//帮助中心
FAQ:"常见问题",//常见问题
Privacy:"隐私",//隐私
Terms:"条款",//条款
ReportIssues:"报告问题",//报告问题
UserGuide:"用户指南",//用户指南
AboutCSI:"关于CSI"//关于CSI


},
MyAccount:{
Logintime:'登录时间',//登录时间
SignOut:'退出',//退出
DeleteAccount:'删除账户',//删除账户
AccountID:'账户ID',//账户ID
Enteranewaddress:'输入新的电邮',//输入新的电邮
EnterVerificationCode:'输入验证码',//输入验证码
SendverificationCode:'发送验证码',//发送验证码
Password:'密码',//密码
Originalpassword:'原始密码',//原始密码
Newpassword:'新密码',//新密码
Confirmnewpassword:'确认新密码',//确认新密码
AccountOwnership:'账户所有权',//账户所有权
IndividualAccount:'个人账户',//个人账户
GroupAccount:'集团账户',//集团账户
Organizationname:'机构名称',//机构名称
CountryRegion:'国家/地区',//国家/地区
Address:'地址',//地址
City:'城市',//城市
ZipCode:'邮政编码',//邮政编码
FirstName:'名字',//名字
LastName:'姓氏',//姓氏
PhoneNumber:'电话号码',//电话号码
Email:'电邮',//更改
Change:'更改',//更改
Save:'保存',//保存
Cancel:'取消',//取消
LastLogin:'上次登录',//Last Login
RecentLogin:'登录尝试次数',//登录尝试次数
AverageLoginTime:'平均登录时间',//平均登录时间
TotalLoginAttempts:'登录尝试次数',//登录尝试次数

},
ShippingOrderDetails:{
    Date:"日期",
    MasterBillofLading:"提单",
    Source:"来源",
    BillNo:"提单号",
    ImporterBuyer:"进口商/买方",
    ExporterSeller:"出口商/卖方",
    Name:"名称",
    Address:"地址",
    Country:"国家/地区",
    Contact:"联系方式",
    Email:"电邮",
    CargoInfo:"货物信息",
    HSCode:"HS 编码",
    Quantity:"数量",
    WeightUnit:"重量单位",
    ProductDescription:"产品描述",
    Amount:"金额",
    QuantityUnit:"数量单位",
    Weight:"重量",
    HSDescription:"HS 描述",
    Incoterms:"国际贸易术语解释通则",
    ShippingInfo:"装运信息",
    Vessel:"船舶",
    Consignee:"收货人",
    MeansofTransport:"运输方式",
    CountryofOrigin:"原产国",
    Voyage:"航次",
    Notifier:"通知人",
    CountryofDestnation:"目的地国",
    AddressofOrigin:"原产地地址",
    Shipper:"托运人",
    AddressofDestnation:"目的地地址",
    Container:"集装箱",
    ContainerID:"集装箱 ID",
    ContainerType:"集装箱类型",
    ContainerDescDode:"集装箱描述号",
    ContainerSize:"集装箱尺寸"
},
ReportIssues:{
    Whattypeoferrorsyouarereporting:"您要报告什么类型的问题？",
    Tellusmoreaboutyourproblems:"告诉我们更多关于您问题的信息",
    Wouldyouliketoprovideascreenshotorafileregardingyourproblem:"您想提供有关问题的屏幕截图或文件吗？",
    Fillinyourcontactinformation:"请填写您的联系信息",
    FirstName:"名字",
    LastName:"姓氏",
    PhoneNumber:"电话号码",
    Email:"电子邮件"
},
UserSettings:{
    LanguageandLocation:"语言和位置",
    Language:"语言",
    Selectyourpreferedlanguage:"选择您的首选语言",
    Location:"位置",
    Selectyourlocation:"选择您的位置",
    NotificationSetting:"通知设置",
    EmailNotification:"电子邮件通知",
    ServiceUpdates:"服务更新",
    CompanyNews:"公司新闻"
},
ContactInfo:{
    ContactInfo:"联系信息",
    FirstName:"名字",
    LastName:"姓氏",
    PhoneNumber:"电话号码",
    Email:"电邮",
    CountryRegion:"国家/地区",
    AddressLine:"地址",
    City:"城市",
    ZipCode:"邮政编码",
    Alternativecontactperson:"备选联系人",
    Setascontactperson:"设置为联系人",
    Edit:"编辑"
},
AccountSecurity:{
    Setupmysecurityquestions:"设置我的安全问题",
    Pleasechooseaquestion:"请选择一个问题",
    Pleaseentertheanswertothequestion:"请输入问题的答案",
    SessionTimeoutAutomaticLogoutSettings:"登录超时：自动注销设置",
    Thesystemwillautomatically:"如果您在一段时间内没有进行任何操作，系统将自动注销您的账户。默认超时时间为5分钟，但您可以根据需要调整此时长。"
},
MyDatabase:{
    TotalNumberofCompaniesSearched:"搜索公司总数",
    TotalNumberofCompaniesCollected:"收集公司总数",
    TotalNumberofUpdateReportsOrdered:"订购更新报告总数",
    Date:"日期",
    UserName:"用户名",
    CompanyName:"公司名称",
    Status:"状态",
    UsageType:"使用类型",
    Entercompanyname:"输入公司名称",
    Download:"下载"
},
OrganizationalManagement:{
    GroupName:"集团名称",
    ParentGroupName:"母群组名称",
    Organization:"组织",
    GroupID:"组编号",
    GroupStatus:"组状态",
    Operation:"操作",
    NewlyBuilt:"新建",
    UserAccount:"用户账号",
    Role:"角色",
    AccountStatus:"账号状态",
    RoleName:"角色名称",
    Position:"职位",
    RoleStatus:"角色状态",
    Valid:"有效",
    Invalid:"无效",
    PermissionSettings:"权限设置"
},
BillingandPayment:{
    TotalNumberofOrders:"订单总数",
    TotalPaymentAmount:"付款总额",
    TotalDeductionCredits:"扣点总数",
    Date:"日期",
    UserAccount:"用户账户",
    CompanyName:"公司名称",
    OrderNo:"订单号",
    OrderType:"订单类型",
    OrderStatus:"订单状态",
    Download:"下载",
    PaymentAmount:"付款金额",
    Contactus:"联系我们",
    DownloadInvoice:"下载发票",
    CreditsDeducted:"已扣款",
    ReportOrderStatus:"报告订单状态",
    CompanyID:"公司 ID",
    CountryRegion:"国家/地区",
    AddressLine:"地址",
    City:"城市",
    ZipCode:"邮政编码",
    FirstName:"名字",
    LastName:"姓氏",
    PhoneNumber:"电话号码",
    Email:"电子邮件",
    BankAccountHolderName:"银行账户持有人姓名",
    BeneficiaryBankName:"收款银行名称",
    SWIFTCODE:"SWIFT 代码",
    AccountNumber:"账号",
    BeneficiaryBankAddress:"收款银行地址",
    ABA:"ABA号",
    IBANnumber:"国际银行账户号码（IBAN）"
},
JiuGuoge:{
  Country:'Country',
  Industry:'Industry',
  CoSize:'Co. Size',
  Liquidity:'Liquidity',
  NoofcoinIndustry:'No. of co. in Industry',
  IndustryRating:'Industry Rating',
  Profitability:'Profitability',
  Growth:'Growth',
  FinancialStructurt:'Financial Structurt',
  Repaying:'Repaying',
},
  ...zhLocale
}

export default cn